import React, { useState, useMemo, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../roleManagement/RoleManagement.scss";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import DataSearch from "../../utils/DataSearch";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import { useRolePermission } from "../../hooks/useRolePermission";
import DeleteModal from "../../components/common/DeleteModal";
import RoleManagementGrid from "../../components/roleManagement/RoleManagementGrid";
import { SearchComponent } from "../../components/common/SearchComponent";
import { CheckNull } from "../../utils/Validate";
import ErrorMessage from "../../components/common/ErrorMessage";

const RoleManagementList = () => {
  const [roleData, setRoleData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: '', textCode: '', text: '', loading: false });
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filterColumn, setFilterColumn] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [deletedMessage, setDeletedMessage] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [listData, setListData] = useState({});

  const { data: roleList, loading: loadingList, error } = FetchData("userrole");

  const baseColumns = [
    {
      heading: "Role Name",
      value: "roleName",
      sortable: true,
    },

    {
      heading: "Status",
      value: "status",
      sortable: true,
    },
  ];

  const { menuRights } = useRolePermission("Role Permission")

  useEffect(() => {
    let filterdata = roleData.map((filterItem, index) => {
      filterItem.roleName = filterItem.name;
      filterItem.status = filterItem.isActive === true ? "Active" : "Inactive";
      filterItem['view'] = menuRights?.canView === true ? 'VIEW' : 'NOT-VIEW'
      return filterItem;
    });
    filterdata = [...filterdata]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (search != '') ApplySearch()
    else setTableData(filterdata)
  }, [roleData, menuRights]);

  useEffect(() => {
    if (roleList) setRoleData(roleList);
  }, [roleList])

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == false) {
      setSelected((oldData) => [...oldData, e.target.value]);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);

  const handleEdit = (item) => {
    if (item)
      navigate("/add-new-user-role", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: 'You want delete this Role?',
      textCode: 'Role Name',
      text: item?.roleName,
      loading: false
    })
  };

  const handleCancelDelete = () => {
    setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true
    })
    DeleteEntry(
      "userrole",
      item,
      setDeletedMessage,
      "Role deleted successfully",
      "Failed to delete role"
    );
  };

  const SuccessDoneClick = () => {
    setSuccessShow(false);
    if (deletedMessage?.message == "Role deleted successfully")
      GetList("userrole", "", setListData);
    else navigate("/role-management");
  };

  useEffect(() => {
    if (deletedMessage?.successData === "Successful") {
      if (CheckNull(deletedMessage?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: "", textCode: "", text: "", loading: false });
        setSuccessShow(true);
      }
    } else {
      if (CheckNull(deletedMessage?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: "", textCode: "", text: "", loading: false });
        setErrorShow({ show: true, errorMessage: deletedMessage.message });
      }
    }
  }, [deletedMessage]);

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(roleData, search, baseColumns);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt)
    });
    setTableData(SearchResult);
    setRefreshSearch(false);
  };

  useEffect(() => {
    if (refreshSearch === true || search == '') ApplySearch();
  }, [search])

  const RefreshList = () => { window.location.reload() }

  useEffect(() => {
    if (listData?.message == "success") {
      setRoleData(listData?.data)
    }
  }, [listData])

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      ApplySearch();
    }
  };

  const addNew = () => {
    navigate('/add-new-user-role', {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit
      }
    })
  }

  const handleView = (item) => {
    menuRights?.canView && navigate('/view-role', {
      state: {
        item: item,
        roleView: "view"
      }
    })
  }

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
  };

  const removeSearch = () => { setSearch(""); setRefreshSearch(true) };

  return (
    <>
      <section id="roleManagementList">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div class="quote-title-group">
                        <p> {tableData?.length} Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                      <SearchComponent
                        //filteredResults={tableData}
                        search={search}
                        handleKeyDown={handleKeyPress}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={roleList}
                        addNew={addNew}
                        moduleName="Role"
                        HideFilter="HideFilter"
                        menuRights={menuRights} />
                    </div>
                  </div>
                  {/* <!-- search-area-sec ends --> */}
                </div>
              </div>
            </div>
          </div>
          <RoleManagementGrid
            filteredResults={tableData}
            filterColumn={filterColumn}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            loading={loadingList}
            menuRights={menuRights}
            moduleName='userrole' />
        </div>
      </section >
      <div className="container-fluid distributer-master-list-sec pl-5 pr-5">
        <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
        <SaveSuccessModel show={successShow} createMsg={deletedMessage} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />
        <ErrorMessage
          Show={errorShow?.show}
          errorMessage={errorShow?.errorMessage}
          ErrorDoneClick={ErrorDoneClick}
        />
      </div>
    </>
  );
};

export default RoleManagementList;